import '@vaadin/confirm-dialog';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '..';

export const tagName = 'tm-confirm-dialog';
@customElement(tagName)
export class TmTextField extends TmBaseComponent {
    @property({ type: Boolean })
    public opened = false;

    @property({ type: String })
    public header?: string;

    @property({ type: String })
    public message?: string;

    @property({ type: String })
    public confirmText = 'Confirm';

    @property({ type: String })
    public confirmTheme = 'primary';

    @property({ type: Boolean })
    public cancel?: boolean;

    @property({ type: String })
    public cancelText = 'Cancel';

    @property({ type: String })
    public cancelTheme = 'tertiary';

    @property({ type: Boolean })
    public reject?: boolean;

    @property({ type: String })
    public rejectText = 'Reject';

    @property({ type: String })
    public rejectTheme = 'error tertiary';

    protected render() {
        return html`
            <vaadin-confirm-dialog
                @confirm=${(e: CustomEvent) => {
                    const cancelEvent = new CustomEvent('confirm', {
                        detail: e.detail,
                    });
                    this.dispatchEvent(cancelEvent);
                }}
                @cancel=${(e: CustomEvent) => {
                    const cancelEvent = new CustomEvent('cancel', {
                        detail: e.detail,
                    });
                    this.dispatchEvent(cancelEvent);
                }}
                @reject=${(e: CustomEvent) => {
                    const cancelEvent = new CustomEvent('confirm', {
                        detail: e.detail,
                    });
                    this.dispatchEvent(cancelEvent);
                }}
                .opened=${this.opened}
                header=${this.header ?? ''}
                message=${this.message ?? ''}
                confirm-text=${this.confirmText}
                confirm-theme=${this.confirmTheme}
                ?cancel-button-visible=${this.cancel}
                cancel-text=${this.cancelText}
                cancel-theme=${this.cancelTheme}
                ?reject-button-visible=${this.reject}
                reject-text=${this.rejectText}
                reject-theme=${this.rejectTheme}
            >
            </vaadin-confirm-dialog>
        `;
    }

    public static get styles() {
        return [
            css`
                vaadin-confirm-dialog-overlay::part(header) {
                    font-size: 2rem;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmTextField;
    }
}
